import rootRender from '../utils/root-render';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share';
import { Menu } from '@headlessui/react';
import copyToClipboard from '@/js/general/copy-to-clipboard';
import { getDataFromPage } from '../utils';

const data = getDataFromPage('react-share-data');

function Share() {
  const { href } = window.location;
  const { strings } = data;

  return (
    <Menu>
      {({ open }) => (
        <div className="share">
          <Menu.Button className="share__button">
            <i className={open ? 'icon-cross' : 'icon-share'}></i>
            <span>{strings.share}</span>
          </Menu.Button>
          <Menu.Items className="share__list">
            <Menu.Item>
              <LinkedinShareButton
                url={href}
                resetButtonStyle={false}
                className="share__list-item"
              >
                <i className="icon-linkedin" />
                <span>{strings.linkedIn}</span>
              </LinkedinShareButton>
            </Menu.Item>
            <Menu.Item>
              <FacebookShareButton
                url={href}
                resetButtonStyle={false}
                className="share__list-item"
              >
                <i className="icon-facebook" />
                <span>{strings.facebook}</span>
              </FacebookShareButton>
            </Menu.Item>
            <Menu.Item>
              <TwitterShareButton
                url={href}
                resetButtonStyle={false}
                className="share__list-item"
              >
                <i className="icon-x" />
                <span>{strings.x}</span>
              </TwitterShareButton>
            </Menu.Item>
            <Menu.Item>
              <button
                onClick={() => copyToClipboard(href)}
                type="button"
                className="share__list-item"
              >
                <i className="icon-copy-link" />
                <span>{strings.copyLink}</span>
              </button>
            </Menu.Item>
          </Menu.Items>
        </div>
      )}
    </Menu>
  );
}

rootRender('react-share', <Share />);
